const initial = {
  building_id: null,
  utility_room_id: null,
  status: 'hidden',
  callback: null
};

export default {
  namespaced: true,
  state: {...initial},
  actions: {
    clear({commit}) {
      commit('CLOSE_FORM');
    },
    create({commit}, {
      utility_room_id,
      callback
    }) {
      commit('SHOW_FORM', {
        status: 'create',
        utility_room_id: utility_room_id,
        building_id: null,
        callback
      });
    },
    edit({commit}, {
      building_id,
      callback
    }) {
      commit('SHOW_FORM', {
        status: 'edit',
        utility_room_id: null,
        building_id: building_id,
        callback
      });
    }
  },
  mutations: {
    CLOSE_FORM(state) {
      state.status = initial.status;
      state.utility_room_id = initial.utility_room_id;
      state.building_id = initial.building_id;
      state.callback = initial.callback;
    },
    SHOW_FORM(state, {
      status,
      utility_room_id,
      building_id,
      callback
    }) {
      state.status = status;
      state.utility_room_id = utility_room_id;
      state.building_id = building_id;
      state.callback = callback || initial.callback;
    }
  }
};
